


















































import Vue from 'vue'
import { CardType, States } from '../models'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import store from '../store'

export default Vue.extend({
  name: 'AddCard',
  data () {
    return {
      card: new CardType({}),
      currentState: 0 as States,
      countdownId: 0,
      countdown: 0,
      states: {
        0: 'Bazinga!',
        200: `Cool! I'll help you memorize that 🥰`,
        500: 'Unable to add.'
      }
    }
  },
  mounted () {
    // browser.runtime.sendMessage({})
  },
  computed: {
    hasSomeValue ():boolean {
      return this.card.hasSomeValue()
    },
    hasValues ():boolean {
      return this.card.hasValues()
    },
    user () {
      return store.state.user
    },
    defaultText () {
      return browser.i18n.getMessage('extName')
    },
    random () {
      return {
        front: 'example: birthdate of your wife?',
        back: '9th April'
      }
    },
    askLogin () {
      return store.state.askLogin
    },
    chosenDeck () {
      return store.state.chosenDeck || store.state.user.uid
    }
  },
  watch: {
    currentState (val:States) {
      let vm = this
      if (val !== 0) {
        vm.beginCountdown()
      }
    }
  },
  methods: {
    goTo (place:string) {
      switch (place) {
        case 'library':
          this.$router.push({ 'name': 'library' })
      }
    },
    beginCountdown () {
      var vm = this
      if (vm.countdownId !== 0) {
        clearInterval(vm.countdownId)
      }
      vm.countdown = 10
      vm.countdownId = window.setInterval(reduceTime, 1000)
      function reduceTime () {
        vm.countdown -= 1
        if (vm.countdown === 0) {
          clearInterval(vm.countdownId)
          vm.resetCurrentState()
        }
      }
    },
    resetCurrentState () {
      let vm = this
      vm.currentState = 0
    },
    async addCard () {
      if (!this.card.hasValues()) {
        this.currentState = 500
        return
      }
      if (this.askLogin) {
        this.$toasted.show('Please login 🙂', { type: 'info', duration: 3000 })
        return
      }
      try {
        var db = firebase.firestore()
        if (this.chosenDeck) {
          let res = await db.collection(`decks/${this.chosenDeck}/cards`).add(this.card.toString())
          this.currentState = 200
          this.clearCard(true)
        } else {
          throw new Error(`User not present ${this.user}`)
        }
      } catch (error) {
        console.log('err', error)
        this.currentState = 500
      }
    },
    clearCard (force:boolean = false) {
      if (!force && this.card.hasSomeValue()) {
        let userIsSure = confirm('Are you sure you want to clear ?')
        if (userIsSure) {
          this.card = new CardType({})
        }
      } else {
        this.card = new CardType({})
      }
    }
  }
})
